export const userInputs = [
    {
      id: 1,
      label: "Nom",
      type: "text",
    },
    
    {
      id: 2,
      label: "Email",
      type: "mail",
      placeholder: "nom@gmail.com",
    },
    {
      id: 3,
      label: "Téléphone",
      type: "text",
    },
    {
      id: 4,
      label: "Mot de passe",
      type: "password",
    },
   
  
  ];
  
  export const productInputs = [
    {
      id: 1,
      label: "Title",
      type: "text",
      placeholder: "Apple Macbook Pro",
    },
    {
      id: 2,
      label: "Description",
      type: "text",
      placeholder: "Description",
    },
    {
      id: 3,
      label: "Category",
      type: "text",
      placeholder: "Computers",
    },
    {
      id: 4,
      label: "Price",
      type: "text",
      placeholder: "100",
    },
    {
      id: 5,
      label: "Stock",
      type: "text",
      placeholder: "in stock",
    },
  ];
  